export const CERTIFICATE = {
    ENTRUST: 'Entrust Certificate',
    DIGI: 'Digi Certificate',
    PEP_ENTERPRISE: 'Pepsico Enterprise CA Certificate',
};
export default {};
